import { Status } from "../status-indicator";
export var BACKGROUND_COLOR_KEY = 'neutral0';
export var DEFAULT_THRESHOLD_COLOR_KEY = 'neutral50';
export var getForegroundColor = function getForegroundColor(status, selectors) {
  switch (status) {
    case Status.Warning:
      return selectors.color('yellow70');

    case Status.Negative:
      return selectors.color('red70');

    case Status.Positive:
      return selectors.color('green70');

    case Status.Loading:
      return selectors.color('primary70');

    default:
      return selectors.color('neutral70');
  }
};
export var getBorderColor = function getBorderColor(status, selectors) {
  switch (status) {
    case Status.Warning:
      return selectors.color('yellow80');

    case Status.Negative:
      return selectors.color('red80');

    case Status.Positive:
      return selectors.color('green80');

    case Status.Loading:
      return selectors.color('primary80');

    default:
      return selectors.color('neutral90');
  }
};